import { useIsMedicalRecordsEnabledVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useIsMedicalRecordsEnabledVariation.js';
export const useIsMedicalRecordsEnabled = () => {
    const { variation, loading } = useIsMedicalRecordsEnabledVariation({ defaultValue: true });
    return {
        enabled: variation,
        loading,
    };
};
//# sourceMappingURL=useIsMedicalRecordsEnabled.js.map